module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "drawer-con"
  }, [_c('div', {
    staticClass: "drawer-content"
  }, [_c('div', {
    staticClass: "swiper-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, _vm._l((_vm.dataLink), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "swiper-slide"
    }, [_c('a', {
      staticClass: "nextToLink",
      attrs: {
        "href": item.dapp_home_url,
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "swiper-slide-con"
    }, [_c('p', {
      staticClass: "slide-title"
    }, [_c('img', {
      style: ({
        'width': item.dapp_name == '北京互联网法院' || item.dapp_name == '广州互联网法院' ? '143px' : 'auto'
      }),
      attrs: {
        "src": item.title_logo
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "slide-desc"
    }, [_vm._v("\n                         " + _vm._s(item.description) + "\n                     ")]), _vm._v(" "), _c('div', {
      staticClass: "next-to-btn"
    }, [_c('a', {
      staticClass: "nextToLink",
      attrs: {
        "href": item.dapp_home_url,
        "target": "_blank"
      }
    }, [_c('span', {
      staticClass: "next-icon"
    })])])])])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-prev"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ffd6060"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/swiperDrawer.vue
// module id = 752
// module chunks = 1